const { default: ApiService } = require("./api.service");

const AppointmentService = {
    create: (appointmentData) => ApiService.fetch('appointments', {
        method: 'POST',
        body: JSON.stringify(appointmentData)
    }),

    createSuggested: (appointmentData) => {
        const data = { ...appointmentData, status: 'suggested' };
        return ApiService.fetch('appointments', {
            method: 'POST',
            body: JSON.stringify(data)
        });
    },

    updateStatus: (appointmentId, status) => ApiService.fetch(`appointments/${appointmentId}/status`, {
        method: 'PUT',
        body: JSON.stringify({ status })
    }),

    updateDateTime: (appointmentId, date, time) => ApiService.fetch(`appointments/${appointmentId}/datetime`, {
        method: 'PUT',
        body: JSON.stringify({ date, time })
    }),

    delete: (appointmentId) => ApiService.fetch(`appointments/${appointmentId}`, {
        method: 'DELETE'
    }),

    getDoctorAppointments: () => ApiService.fetch('therapist/appointments'),

    getPatientAppointments: () => ApiService.fetch('patient/appointments'),

    getAdminAppointments: (filters = {}) => {
        const params = new URLSearchParams();

        Object.keys(filters).forEach(key => {
            if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
                params.append(key, filters[key]);
            }
        });

        const queryString = params.toString();
        const url = queryString ? `admin/appointments?${queryString}` : 'admin/appointments';

        return ApiService.fetch(url);
    },

    addFeedback: (appointmentId, feedback, rating) => ApiService.fetch(`appointments/${appointmentId}/status`, {
        method: 'PUT',
        body: JSON.stringify({
            status: 'completed',
            feedback,
            feedback_rating: rating
        })
    }),

};

export default AppointmentService;